import { render } from "./Home.vue?vue&type=template&id=09f20c50&scoped=true"
import script from "./Home.ts?vue&type=script&lang=js"
export * from "./Home.ts?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=09f20c50&lang=scss&scoped=true"

import exportComponent from "/Users/lucatescari/Documents/Projects/Private/rt-songpage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f20c50"]])

export default __exports__